const HOUR = 60 * 60 * 1000;
const CHECK_INTERVAL = 5 * 60 * 1000;
const URL = `${import.meta.env.VITE_API_URL || ""}/api`;

let intervalId: number | null = null;
let isSending = false;

const getToken = () => localStorage.getItem("accessToken");
const getLastPing = () => Number(localStorage.getItem("lastPing") || 0);
const setLastPing = (ts: number) => localStorage.setItem("lastPing", ts.toString());

const sendEntryPing = async () => {
  if (isSending) return;

  const token = getToken();
  if (!token) return;

  const now = Date.now();
  const lastPing = getLastPing();

  if (now - lastPing < HOUR) return;

  isSending = true;

  try {
    const res = await fetch(`${URL}/auth/track-entry`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json();

    if (!data.set) return;

    setLastPing(now);
  } catch (err) {
    console.log(err);
  } finally {
    isSending = false;
  }
};

export const startTracking = () => {
  if (intervalId) return;

  sendEntryPing();

  intervalId = window.setInterval(() => {
    sendEntryPing();
  }, CHECK_INTERVAL);
};

export const stopTracking = () => {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
};

document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") {
    startTracking();
  } else {
    stopTracking();
  }
});

if (document.visibilityState === "visible") startTracking();
